var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("404 Not Found")]),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.$router.push('/my-page')}}},[_vm._v("戻る")])])}
var staticRenderFns = []

export { render, staticRenderFns }